import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import PersonsContent from "./PersonsContent/PersonsContent";
import { Values } from "@src/Tools/Values";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
class ManagePersons extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getActivePositions(),
        this.props.management.getActiveLocations(),
        this.props.management.getActiveOrganisations(),
        this.props.management.getPersons(),
        this.props.management.getActivePermissions(),
      ]);

      this.isLoading = false;
      document.title = Values.getLocalizationValue("persons");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <PersonsContent />}</div>;
  }
}

export default ManagePersons;
